<template>
    <div>
        <v-container>
            <v-row >
                <v-col cols="6">
                    <v-select
                            v-model="template"
                            :items="templates"
                            item-text="name"
                            return-object
                            label="Templates"
                            @change="selectionChange"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row v-if="template">
                <v-col cols="2">
                    Path
                </v-col>
                <v-col cols="4">
                    {{ path }}
                </v-col>
            </v-row>
            <v-row v-if="template">
                <v-col cols="2">
                    Method
                </v-col>
                <v-col cols="4">
                    {{ template.method }}
                </v-col>
            </v-row>
            <v-row v-if="template && template.method === 'GET'">
                <v-col cols="6">
                    <v-text-field
                            label="Query parameters"
                            v-model="text"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="template && template.method === 'POST'">
                <v-col>
                    <v-textarea
                            label="Body"
                            v-model="text"
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row v-if="template">
                <v-col cols="6">
                    <v-btn rounded color="primary" class="mr-5" @click="sendRequest">Send request</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="response">
                <v-col cols="6">
                    Response from hansong cloud

                    <pre>{{ response | pretty }}</pre>
                </v-col>
            </v-row>
            <v-row v-if="error">
                <v-col cols="6" style="color: red">
                    Error received from Spottune cloud

                    <v-textarea
                            readonly
                            v-model="error"
                    ></v-textarea>
                </v-col>
            </v-row>
    </v-container>
    </div>
</template>

<script>
    export default {
        name: 'RawHansong',
        data() {
            return {
                templates: [
                    {
                        name: "Device functions",
                        path: "/v1/api/device/functions/",
                        method: "GET",
                        template: "device_id=%DEVICEID%"
                    },
                    {
                        name: "Device status",
                        path: "/v1/api/device/status/",
                        method: "POST",
                        template: '{"deviceId":"%DEVICEID%","containSub":true,"accessoryId":""}'
                    },
                    {
                        name: "Set zone volume",
                        path: "/v1/api/device/control/",
                        method: "POST",
                        template: '{"deviceId":"%DEVICEID%","operation":{"optCode":"zoneVolume","value":{"zoneId":"zone1","minVolume":0,"maxVolume":100,"curVolume":25}}}'
                    },
                    {
                        name: "Set zone source",
                        path: "/v1/api/device/control/",
                        method: "POST",
                        template: '{"deviceId":"%DEVICEID%","operation":{"optCode":"zoneSourceChange","value":{"zoneId":"zone1","zoneSourceId":"1"}}}'
                    },
                    {
                        name: "Set speaker volume",
                        path: "/v1/api/device/control/",
                        method: "POST",
                        template: '{"deviceId":"%DEVICEID%","accessoryId":"%SPEAKERID%","operation":{"optCode":"speakerVolume","value":{"minVolume":0,"maxVolume":100,"curVolume":0}}}'
                    }

                ],
                template: undefined,
                text: undefined,
                response: undefined,
                error: undefined
            }
        },
        methods: {
            selectionChange() {
                this.text = this.template.method === "POST"?this.$options.filters.pretty(this.template.template):this.template.template;
                this.error = "";
                this.response = "";
            },
            success(res) {
                this.log(res);
                if (res.data.code === 200) {
                    this.response = res.data.result;
                    this.error = undefined;
                } else {
                    this.error = JSON.stringify(res.data);
                    this.response = undefined;
                }
            },
            errorReceived(reason) {
                this.error = JSON.stringify(reason);
                this.response = undefined;
            },
            sendRequest() {
                if (this.template) {
                    const body = this.template.method === "POST"?this.text:"";
                    this.model.send(this.path, this.template.method, body)
                        .then(res => this.success(res))
                        .catch(reason => this.errorReceived(reason))
                }
            }
        },
        computed: {
            path() {
                return this.template.method === "POST"?this.template.path:this.template.path +"?"+ this.text;
            }
        },
        filters: {
            pretty(value) {
                return JSON.stringify(JSON.parse(value), null, 2);
            }
        }
    }
</script>
